/**
 * Owner 2026-10-24 (pkt 3): „Pozwalasz dopożyczyć od dostawcy więcej niż ma w katalogu … musi być wyświetlone, że max
 * ileś tam. Nie można dopożyczyć czegoś, czego nie ma.” The supplier position's „Ilość posiadanych” as the form knows
 * it (rule 7a: undefined when the role does not see it — the server still refuses, without a number).
 */

type Position = { id: string; supplierId?: string; quantity?: number | null };

/**
 * The stock of `supplierId`: the chosen position's (when it is this supplier's), else the supplier's position of the
 * item among `prices`. Null: not known (no cap); undefined: no such position or its quantity is not seen.
 */
export function stockOfSupplier(supplierId: string, chosen: { priceId: string; supplierId?: string; quantity?: number | null } | null, prices: readonly Position[] | undefined): number | null | undefined {
  if (chosen && chosen.supplierId === supplierId && chosen.quantity !== undefined) return chosen.quantity;
  return prices?.find((p) => p.supplierId === supplierId)?.quantity;
}

/** Why `quantity` cannot be rented when the supplier has `stock` pieces left on these days (null: it can). */
export function stockProblem(quantity: number, stock: number | null | undefined, supplierName: string): string | null {
  if (stock === null || stock === undefined || quantity <= stock) return null;
  return `${supplierName}: możesz dopożyczyć najwyżej ${stock} szt. — tyle zostało u dostawcy w tych dniach.`;
}

/** „ma N szt.” for a supplier chooser ('' when not known or not seen). */
export const stockLabel = (stock: number | null | undefined): string => (stock === null || stock === undefined ? '' : `ma ${stock} szt.`);

/**
 * Owner 2026-10-24 16:15: „nie pozwól wpisać w oknie więcej niż maks. — jeśli więcej wpisze, to zmieniaj na max”. A
 * whole number over `max` becomes `max` as it is typed; anything else stays as typed (the save says what is wrong).
 */
export function clampToMax(typed: string, max: number | null | undefined): string {
  if (typeof max !== 'number') return typed;
  const t = typed.trim();
  if (!/^\d+$/.test(t)) return typed;
  return Number(t) > max ? String(max) : typed;
}
